import { useState } from 'react';

import { ChevronDownIcon } from '@workinance/shared/ui/icons';

import { SwitchBusinessModalComponent } from '@/components/dashboard/SwitchBusinessModalComponent';
import { useAuthStore } from '@/store/auth.store';

const pillClasses =
	'flex max-w-full min-w-0 items-center gap-2.5 rounded-full border border-rule bg-panel py-1 pr-3 pl-1 text-left text-ink';

/**
 * The business the dashboard is working in, at the centre of the top bar. An owner with more than one
 * business can click it to switch; everyone else sees it as a plain label.
 */
export function BusinessSwitcherComponent() {
	const business = useAuthStore((state) => state.business);
	const isOwner = useAuthStore((state) => state.isOwner());
	const businessCount = useAuthStore((state) => state.businesses.length);
	const [isSwitchOpen, setIsSwitchOpen] = useState(false);

	if (!business) return null;

	const canSwitch = isOwner && businessCount > 1;
	const content = (
		<>
			<span
				aria-hidden="true"
				className="grid size-7.5 shrink-0 place-items-center rounded-full bg-brand-soft text-[13px] font-bold text-brand"
			>
				{business.name.charAt(0).toUpperCase()}
			</span>
			<span className="flex min-w-0 flex-col leading-tight">
				<span className="truncate text-sm font-semibold">{business.name}</span>
				<span className="font-code text-[11px] text-mute">
					Code {business.businessCode}
				</span>
			</span>
		</>
	);

	if (!canSwitch) return <div className={pillClasses}>{content}</div>;

	return (
		<>
			<button
				type="button"
				aria-haspopup="dialog"
				onClick={() => setIsSwitchOpen(true)}
				className={`${pillClasses} cursor-pointer transition-colors hover:bg-brand-soft/60`}
			>
				{content}
				<ChevronDownIcon className="size-4 shrink-0 text-mute" />
			</button>
			<SwitchBusinessModalComponent
				isOpen={isSwitchOpen}
				onClose={() => setIsSwitchOpen(false)}
			/>
		</>
	);
}
